import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const health: ImportTypeConfig = {
  type: 'health',
}
